import { Grid } from '@mui/material';
import { OrbitSectionHeader } from '../components/orbitSectionHeader';
import { OrbitAddressForm } from './form';
import { OrbitAddressProps } from '../sectionProps';

export const OrbitAddress = (props: OrbitAddressProps) => (
    <>
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12}>
                <OrbitSectionHeader title="Dirección" />
            </Grid>
        </Grid>
        <OrbitAddressForm {...props} />
    </>
);
